/*
 * Generated type guards for "lastOrder.ts".
 * WARNING: Do not manually change this file.
 */
import { EFreeDeliveryOptionFlag } from "../../services/orderAsLastTime/validateCart/model";
import { ILastOrderResponse, IValidatedLastOrderResponse, IBaseAddress, IDeliveryAddress, IInvoiceAddress, IDeliveryInfo, IDistributionPoint, IPaymentInfoResponse } from "./lastOrder";

export function isLastOrder(obj: any, _argumentName?: string): obj is ILastOrderResponse {
    return (
        (obj !== null &&
            typeof obj === "object" ||
            typeof obj === "function") &&
        typeof obj.sameDeliveryAndInvoice === "boolean" &&
        isBaseAddress(obj.deliveryAddress) as boolean &&
        isInvoiceAddress(obj.invoiceAddress) as boolean &&
        isDeliveryInfo(obj.deliveryInfo) as boolean &&
        (typeof obj.orderPricesSummary === "undefined" ||
            (obj.orderPricesSummary !== null &&
                typeof obj.orderPricesSummary === "object" ||
                typeof obj.orderPricesSummary === "function") &&
            typeof obj.orderPricesSummary.deliveryPrice === "number" &&
            typeof obj.orderPricesSummary.paymentPrice === "number" &&
            typeof obj.orderPricesSummary.totalPrice === "number") &&
        (typeof obj.freeDeliveryOptionFlag === "undefined" ||
            obj.freeDeliveryOptionFlag === EFreeDeliveryOptionFlag.NONE ||
            obj.freeDeliveryOptionFlag === EFreeDeliveryOptionFlag.CHANGE_DELIVERY ||
            obj.freeDeliveryOptionFlag === EFreeDeliveryOptionFlag.CHANGE_DELIVERY_TO_NOTINO_BRANCH ||
            obj.freeDeliveryOptionFlag === EFreeDeliveryOptionFlag.CHANGE_PAYMENT_TO_ONLINE ||
            obj.freeDeliveryOptionFlag === EFreeDeliveryOptionFlag.CHANGE_DELIVERY_AND_PAYMENT) &&
        isPaymentInfo(obj.paymentInfo) as boolean
    )
}

export function isValidatedLastOrder(obj: any, _argumentName?: string): obj is IValidatedLastOrderResponse {
    return (
        (obj !== null &&
            typeof obj === "object" ||
            typeof obj === "function") &&
        typeof obj.isValid === "boolean" &&
        (obj.lastOrder === null ||
            isLastOrder(obj.lastOrder) as boolean)
    )
}

export function isBaseAddress(obj: any, _argumentName?: string): obj is IBaseAddress {
    return (
        (obj !== null &&
            typeof obj === "object" ||
            typeof obj === "function") &&
        typeof obj.company === "string" &&
        typeof obj.firstName === "string" &&
        typeof obj.lastName === "string" &&
        typeof obj.secondName === "string" &&
        typeof obj.street === "string" &&
        typeof obj.city === "string" &&
        typeof obj.zipCode === "string" &&
        typeof obj.region === "string" &&
        typeof obj.district === "string" &&
        typeof obj.flatNumber === "string" &&
        typeof obj.email === "string" &&
        typeof obj.phone === "string" &&
        (obj.streetType === null ||
            typeof obj.streetType === "number") &&
        typeof obj.streetNumber === "string" &&
        typeof obj.neighborhood === "string" &&
        typeof obj.blockNo === "string" &&
        typeof obj.entrance === "string" &&
        (obj.districtType === null ||
            typeof obj.districtType === "number") &&
        (obj.floor === null ||
            typeof obj.floor === "number") &&
        typeof obj.province === "string" &&
        typeof obj.info === "string" &&
        typeof obj.note === "string" &&
        typeof obj.countryId === "string"
    )
}

export function isDeliveryAddress(obj: any, _argumentName?: string): obj is IDeliveryAddress {
    return (
        (obj !== null &&
            typeof obj === "object" ||
            typeof obj === "function") &&
        typeof obj.company === "string" &&
        typeof obj.firstName === "string" &&
        typeof obj.lastName === "string" &&
        typeof obj.secondName === "string" &&
        typeof obj.street === "string" &&
        typeof obj.city === "string" &&
        typeof obj.zipCode === "string" &&
        typeof obj.region === "string" &&
        typeof obj.district === "string" &&
        typeof obj.flatNumber === "string" &&
        typeof obj.email === "string" &&
        typeof obj.phone === "string" &&
        (obj.streetType === null ||
            typeof obj.streetType === "number") &&
        typeof obj.streetNumber === "string" &&
        typeof obj.neighborhood === "string" &&
        typeof obj.blockNo === "string" &&
        typeof obj.entrance === "string" &&
        (obj.districtType === null ||
            typeof obj.districtType === "number") &&
        (obj.floor === null ||
            typeof obj.floor === "number") &&
        typeof obj.province === "string" &&
        typeof obj.info === "string" &&
        typeof obj.note === "string" &&
        typeof obj.countryId === "string"
    )
}

export function isInvoiceAddress(obj: any, _argumentName?: string): obj is IInvoiceAddress {
    return (
        isBaseAddress(obj) as boolean &&
        typeof obj.cin === "string" &&
        typeof obj.tin === "string" &&
        (obj.companyIdentificationData !== null &&
            typeof obj.companyIdentificationData === "object" ||
            typeof obj.companyIdentificationData === "function") &&
        typeof obj.companyIdentificationData.companyRegistrationNumber === "string" &&
        typeof obj.companyIdentificationData.recipientCode === "string" &&
        typeof obj.companyIdentificationData.pecCode === "string" &&
        typeof obj.personalIdentificationNumber === "string"
    )
}

export function isDeliveryInfo(obj: any, _argumentName?: string): obj is IDeliveryInfo {
    return (
        (obj !== null &&
            typeof obj === "object" ||
            typeof obj === "function") &&
        typeof obj.isPersonalPickup === "boolean" &&
        typeof obj.deliveryTypeId === "number" &&
        typeof obj.deliveryName === "string" &&
        typeof obj.deliveryPrice === "number" &&
        obj.deliveryTime instanceof Date &&
        isDistributionPoint(obj.distributionPoint) as boolean
    )
}

export function isDistributionPoint(obj: any, _argumentName?: string): obj is IDistributionPoint {
    return (
        (obj !== null &&
            typeof obj === "object" ||
            typeof obj === "function") &&
        typeof obj.noAddressForPersonalPickup === "boolean" &&
        typeof obj.distributionPointId === "string"
    )
}

export function isPaymentInfo(obj: any, _argumentName?: string): obj is IPaymentInfoResponse {
    return (
        (obj !== null &&
            typeof obj === "object" ||
            typeof obj === "function") &&
        typeof obj.paymentType === "number" &&
        typeof obj.paymentPrice === "number" &&
        typeof obj.paymentName === "string" &&
        typeof obj.providerType === "string" &&
        (typeof obj.paypalTokenAvailable === "undefined" ||
            obj.paypalTokenAvailable === false ||
            obj.paypalTokenAvailable === true) &&
        (typeof obj.paymentGroups === "undefined" ||
            Array.isArray(obj.paymentGroups) &&
            obj.paymentGroups.every((e: any) =>
                typeof e === "string"
            ))
    )
}
